module.exports = __webpack_public_path__ + "img/pdf-lite.f96150fc.png";